export const API_URL = process.env.VUE_APP_API_URL;
export const LCMS_URL = process.env.VUE_APP_LCMS_URL;
export const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_API_KEY = process.env.VUE_APP_GOOGLE_API_KEY;
export const GOOGLE_SHEET_ID = process.env.VUE_APP_GOOGLE_SHEET_ID;
export const VUE_APP_CHAT_CLIENT_URL = process.env.VUE_APP_CHAT_CLIENT_URL;
export const PAGE_LIMIT = 25;
